export const initialState = {
  products: [],
  totalQuntity: 0,
};
